import {AventiObject} from 'src/app/models/AventiObject';

export type Key = { label: string, value: string, objects: AventiObject[] | undefined };

export enum KEY_VALUE {
  NAME = 'name',
  TFM_TAG = 'tfmTag',
  RDS_TAG = 'rdsTag'
}
